import { pick } from 'lodash';
import { HELPER_TEXT_ATTRIBUTES, LABEL_ATTRIBUTES } from '~/assets/javascript/constants';

export default class SubpageInfoComponentFromOptionBuilder {
  static build(infoComponentOption) {
    return new SubpageInfoComponentFromOptionBuilder(infoComponentOption).build();
  }

  constructor(infoComponentOption) {
    this.subpageInfoComponentOption = infoComponentOption;
  }

  build() {
    return {
      ...pick(
        this.subpageInfoComponentOption,
        [
          'columns',
          'id',
          'page_key',
          'page_params',
          'rows',
          'type',
          'view_id',
          ...HELPER_TEXT_ATTRIBUTES,
          ...LABEL_ATTRIBUTES,
        ],
      ),
    };
  }
}
